// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3Jw0o","button":"button___b9ssK","wrapper":"wrapper___1hv9Z","lgUp":"lgUp___1yAhc","searchCorrectionQuery":"searchCorrectionQuery___1Kpk9"};